import { render, staticRenderFns } from "./BaiscTab.vue?vue&type=template&id=34a62d98&scoped=true"
import script from "./BaiscTab.vue?vue&type=script&lang=js"
export * from "./BaiscTab.vue?vue&type=script&lang=js"
import style0 from "./BaiscTab.vue?vue&type=style&index=0&id=34a62d98&prod&lang=scss"
import style1 from "./BaiscTab.vue?vue&type=style&index=1&id=34a62d98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a62d98",
  null
  
)

export default component.exports